import { render, staticRenderFns } from "./ConversationHistory.vue?vue&type=template&id=70625f06&scoped=true"
import script from "./ConversationHistory.vue?vue&type=script&lang=js"
export * from "./ConversationHistory.vue?vue&type=script&lang=js"
import style0 from "./ConversationHistory.vue?vue&type=style&index=0&id=70625f06&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70625f06",
  null
  
)

export default component.exports